module.exports = __webpack_public_path__ + "static/img/200229.ede8309d.png";